import { ACTION_SERVICE_NAME, ActionServiceProvider } from './action.service'

export const ACTION_SERVICES_MODULE_NAME = 'simax.services.action'

const actionServicesModule = angular.module(ACTION_SERVICES_MODULE_NAME, [])

actionServicesModule.provider(ACTION_SERVICE_NAME, ActionServiceProvider)
